import { LimitKeys, limitKeys, UserLimits } from '@griply/types';

export const unlimitedLimit = -1;

export const defaultLimitKeyMap: Record<LimitKeys, number> = {
  [LimitKeys.CreateGoal]: 2,
  [LimitKeys.CreateHabit]: 2,
  [LimitKeys.HabitIcons]: 0,
  [LimitKeys.HabitScheduleTarget]: 0,
  [LimitKeys.CreateSmartList]: 3,
  [LimitKeys.GoalUserPhoto]: 0,
  [LimitKeys.BiometricAppLock]: 0,
  [LimitKeys.CustomLifeAreas]: 0,
  [LimitKeys.CustomizeDefaultLifeAreas]: 0,
  [LimitKeys.EditLifeAreas]: 0,
  [LimitKeys.VisionUserPhoto]: 0,
  [LimitKeys.SubGoals]: 0,
  [LimitKeys.Insights]: 0,
  [LimitKeys.MobileCalendar1DayView]: 0,
  [LimitKeys.MobileCalendar2DayView]: 0,
  [LimitKeys.MobileCalendar3DayView]: 0,
  [LimitKeys.MobileCalendarWeekView]: 0,
  [LimitKeys.DesktopCalendarDay]: 0,
  [LimitKeys.DesktopCalendarWeek]: 0,
  [LimitKeys.DesktopCalendarFourDays]: 0,
  [LimitKeys.DesktopCalendarMonth]: 0,
  [LimitKeys.DesktopGoalsOverviewTimeline]: 0,
  [LimitKeys.MobileGoalsOverviewTimeline]: 0,
};

export const premiumLimitKeyMap: Record<LimitKeys, number> = {
  [LimitKeys.CreateGoal]: unlimitedLimit,
  [LimitKeys.CreateHabit]: unlimitedLimit,
  [LimitKeys.HabitIcons]: unlimitedLimit,
  [LimitKeys.HabitScheduleTarget]: unlimitedLimit,
  [LimitKeys.CreateSmartList]: unlimitedLimit,
  [LimitKeys.GoalUserPhoto]: unlimitedLimit,
  [LimitKeys.BiometricAppLock]: unlimitedLimit,
  [LimitKeys.CustomLifeAreas]: unlimitedLimit,
  [LimitKeys.CustomizeDefaultLifeAreas]: unlimitedLimit,
  [LimitKeys.EditLifeAreas]: unlimitedLimit,
  [LimitKeys.VisionUserPhoto]: unlimitedLimit,
  [LimitKeys.SubGoals]: unlimitedLimit,
  [LimitKeys.Insights]: unlimitedLimit,
  [LimitKeys.MobileCalendar1DayView]: unlimitedLimit,
  [LimitKeys.MobileCalendar2DayView]: unlimitedLimit,
  [LimitKeys.MobileCalendar3DayView]: unlimitedLimit,
  [LimitKeys.MobileCalendarWeekView]: unlimitedLimit,
  [LimitKeys.DesktopCalendarDay]: unlimitedLimit,
  [LimitKeys.DesktopCalendarWeek]: unlimitedLimit,
  [LimitKeys.DesktopCalendarFourDays]: unlimitedLimit,
  [LimitKeys.DesktopCalendarMonth]: unlimitedLimit,
  [LimitKeys.DesktopGoalsOverviewTimeline]: unlimitedLimit,
  [LimitKeys.MobileGoalsOverviewTimeline]: unlimitedLimit,
};

export type GetLimitsOptions = {
  limitKeyMap?: Record<LimitKeys, number>;
  enforcedOverwrites?: Partial<Record<LimitKeys, Date | null>>;
  enforcedAt?: Date;
};

const defaultOptions: Required<
  Pick<GetLimitsOptions, 'limitKeyMap' | 'enforcedOverwrites' | 'enforcedAt'>
> = {
  limitKeyMap: defaultLimitKeyMap,
  enforcedOverwrites: {},
  enforcedAt: new Date(),
};

export const getLimits = ({
  enforcedOverwrites = defaultOptions.enforcedOverwrites,
  limitKeyMap = defaultOptions.limitKeyMap,
  enforcedAt = defaultOptions.enforcedAt,
}: GetLimitsOptions = defaultOptions) =>
  limitKeys.reduce<UserLimits>((acc, key) => {
    acc[key] = {
      limit: limitKeyMap[key],
      enforcedAt: enforcedOverwrites[key] ?? enforcedAt,
    };
    return acc;
  }, {} as UserLimits);

export const getPremiumLimits = (enforcedAt = defaultOptions.enforcedAt) =>
  getLimits({ limitKeyMap: premiumLimitKeyMap, enforcedAt });
